import * as React from 'react';
import * as UI from 'core/ui';
import { Res, Permission, InvoiceDTO, CustomerDetailsDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as InvoicePreconditions from './Preconditions';
import * as InvoiceStore from './InvoiceStore';
import { ActionButtonDefinition, InfoCard, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';
import * as Images from 'pos/Images';
import { Flex } from 'core/ui';
import { Modal } from 'core/ui-next/modal';


async function getCustomer(invoice: InvoiceDTO): Promise<Result<CustomerDetailsDTO>> {
	return Command.execute('searchCustomerByText', invoice.Customer.FiscalName);
}

class ConfirmCustomerDataScreen extends PosStatelessScreenClassComponent<{ customer: CustomerDetailsDTO } & Modal.Actions<void>> {

	onComponentDidMount(): void {
	}

	onComponentWillUnmount(): void {
	}

	protected getScreenId(): string {
		return 'CONVERT_INVOICE_TO_STANDARD';
	}

	protected getTitle(): string {
		return Res.Web.CONVERT_TO_STANDARD_CONFIRM_CUSTOMER();
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getImage(): string | React.FunctionComponent<React.SVGProps<SVGSVGElement>> {
		return Images.CreateInvoice;
	}

	protected useKeypad(): boolean {
		return false;
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return this.okCancelButtons({
			onOK: async () => this.close()
		});
	}

	protected getContent(): React.ReactNode {
		const { customer } = this.props;
		return <Flex.Vertical>
			<Flex.Item>
				<InfoCard Icon='fa fa-id-card-o' title={customer.FiscalName} lines={[customer.BusinessName, customer.Cif, customer.Type.Name]} />
				<InfoCard Icon='fa fa-building-o' title={customer.Address.Street} lines={[`${customer.Address.ZipCode} ${customer.Address.Region}`]} />
				{customer.DiscountRate
					? <InfoCard Icon='fa fa-star-o' title={Res.Web.SHOW_CUSTOMER_CONDITIONS_LBL()} lines={[Res.Web.SHOW_CUSTOMER_DISCOUNT_LBL(UI.Format.asPercentage(customer.DiscountRate * 100))]} />
					: null}
			</Flex.Item>
		</Flex.Vertical>;
	}
}

async function confirmConversion(customer: CustomerDetailsDTO): Promise<Result> {
	return Modal.show(ConfirmCustomerDataScreen, { customer: customer });
}

declare global {
	interface CommandType {
		convertInvoiceToStandard: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('convertInvoiceToStandard', Preconditions.ensure(Permission.Ticket_Invoice), async (invoice: InvoiceDTO): Promise<Result> => {

	const success = await InvoicePreconditions.ensureCanConvertToStandard(invoice);
	if (!success)
		return Result.error();

	const customerResult = await getCustomer(invoice);

	if (!customerResult.ok)
		return Result.error();

	const customer = customerResult.value;

	const confirmResult = await confirmConversion(customer);
	if (!confirmResult.ok)
		return Result.error();

	await InvoiceStore.convertToStandard(invoice.Id, customer);
	return Result.ok();
});
